import {AbstractService} from 'services/AbstractService';

const CURRENT_ACCOUNT_URL = '/api/accounts/';
const IMPERSONATION_URL = '/api/impersonation';

export class AccountSellerService extends AbstractService {
  getCurrentAccount (accountId) {
    return this.client.get(`${CURRENT_ACCOUNT_URL}${accountId}`);
  }

  getImpersonated (payload) {
    return this.client.put(`${IMPERSONATION_URL}`, payload);
  }
}
